module.exports = __webpack_public_path__ + "static/main-image-7478bd8eeb93d047efd8ef9dada1a600.png";